import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsAllSides: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowsAllSides"><Path fillRule="evenodd" clipRule="evenodd" d="M12 1.58594L16.4142 6.00015L15 7.41436L12 4.41436L9 7.41436L7.58578 6.00015L12 1.58594ZM7.41421 9.00015L4.41421 12.0002L7.41421 15.0002L6 16.4144L1.58578 12.0002L6 7.58594L7.41421 9.00015ZM18 7.58594L22.4142 12.0002L18 16.4144L16.5858 15.0002L19.5858 12.0002L16.5858 9.00015L18 7.58594ZM9 16.5859L12 19.5859L15 16.5859L16.4142 18.0002L12 22.4144L7.58578 18.0002L9 16.5859Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsAllSides;
